import type { SwiperContainer } from "swiper/element"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssAutoplay from "swiper/element/css/autoplay?raw"
import { Autoplay } from "swiper/modules"
import { getAdvertsCardType } from "../azm/get-advert-card-view-type.ts" //TODO make Global?
import { advertNewsCardsContainerElement } from "../global/dom.ts"
import { getLocation } from "../location/location"
import {
    getPagesLoadedCount as newsPaginationLoadedCount,
    getPreviousPageToLoad as newsPrevPageToLoad,
} from "../news/pagination/pagination"
import { isMobile } from "../util/device"
import { initSwiperContainer } from "../util/swiper"

const newsPageAnnouncementCards = () =>
    Array.from(advertNewsCardsContainerElement()?.children || []).filter(
        (child) => child.classList.contains("news-anzeige") && !child.classList.contains("self-promotional-banner"),
    )

const staticBannersMobile = {
    // 35           Überregional
    crossRegionalTeaser: {
        html: siteConfig.templates.crossRegionalAdverts,
        position: 35,
        removableViaAdFree: false,
    },
    // 20           Location-Teaser - City
    locationTeaser20: {
        position: 20,
        html: "", // html will be added from api
        removableViaAdFree: false,
    },
    // 35           Location-Teaser - Überregional, Location-Teaser- Regional
    locationTeaser35: {
        position: 35,
        html: "", // html will be added from api
        removableViaAdFree: false,
    },
    // 5
    parallaxBannerTeaser: {
        position: 5,
        html: "", // html will be added from api
        removableViaAdFree: false,
    },
}

let bannersFromApi: null | {
    locationTeaserBanners: string[]
    marketplaceBanners: string[]
    pcMarketplaceBanners: string[]
    parallaxAdBanners: string[]
} = null
let marketplaceBannerGetIndex = 0
let staticBannersInserted: string[] = []
let marketplaceBannersInserted: number[] = []

function getNewsPageMarketplaceBannerPositionsMobile() {
    const MARKET_PLACE_START = 15
    const MARKET_PLACE_EVERY_NTH = 25

    const cardsNotLoadedUntilPage0 = newsPrevPageToLoad() * SearchConfig.pagination.cardsPerPage
    const totalCardsLoaded = newsPaginationLoadedCount() * SearchConfig.pagination.cardsPerPage

    let index = MARKET_PLACE_START
    const largestPossibleIndex = totalCardsLoaded + cardsNotLoadedUntilPage0
    const indices = []
    while (index <= largestPossibleIndex) {
        if (index < cardsNotLoadedUntilPage0) {
            index += MARKET_PLACE_EVERY_NTH
            continue
        }

        indices.push(index)
        index += MARKET_PLACE_EVERY_NTH
    }

    return indices
}

export async function insertAllAdvertBanners(reinsertAllBanners = false, reloadBannersFromApi = false) {
    if (reloadBannersFromApi) {
        bannersFromApi = null
    }

    if (reinsertAllBanners) {
        staticBannersInserted = []
        marketplaceBannersInserted = []

        for (const el of Array.from(advertNewsCardsContainerElement()?.querySelectorAll(".external-banner") || [])) {
            el.remove()
        }
        for (const el of Array.from(
            advertNewsCardsContainerElement()?.querySelectorAll(".banner-free-container") || [],
        )) {
            el.remove()
        }
        for (const el of Array.from(
            advertNewsCardsContainerElement()?.querySelectorAll(".self-promotional-banner") || [],
        )) {
            el.remove()
        }

        for (const el of Array.from(
            advertNewsCardsContainerElement()?.querySelectorAll(".location-teaser-banner") || [],
        )) {
            el.remove()
        }
        for (const el of Array.from(advertNewsCardsContainerElement()?.querySelectorAll(".parallax-ad-banner") || [])) {
            el.remove()
        }
        advertNewsCardsContainerElement()?.querySelector(".top-anzeigen.cross-regional-adverts")?.remove()
    }

    if (bannersFromApi === null) {
        bannersFromApi = await fetchAdvertBanners()
        if (bannersFromApi) {
            staticBannersMobile.locationTeaser20.html = bannersFromApi.locationTeaserBanners[0] || ""
            staticBannersMobile.locationTeaser35.html = bannersFromApi.locationTeaserBanners[1] || ""
            staticBannersMobile.parallaxBannerTeaser.html = bannersFromApi.parallaxAdBanners.join("") || ""
        }
    }

    // static banners include banners that are not removable via adfree
    if (isMobile()) {
        await insertStaticBannersMobile()
        if (!userData.hasAdFree) await insertNewsPageMarketplaceBanners()
    } else {
        await insertStaticBannersPc()
    }

    if (staticBannersMobile.parallaxBannerTeaser.html) {
        window.dispatchEvent(new CustomEvent("parallax-ad.inserted"))
    }
}

// TODO could be made not only azm [ask DM]
async function insertStaticBannersPc() {
    if (!bannersFromApi) {
        return
    }

    const section = document.querySelector("#additional-location-teaser")
    if (section) {
        // City, Regio/Überregio, Eigenwerbung
        section.innerHTML = `<div class="container">
            <swiper-container init="false" id="swiper-location-teaser" speed="600" autoplay="" autoplay-delay="5000" loop="" allow-touch-move="false">
                ${bannersFromApi.pcMarketplaceBanners.map((html) => `<swiper-slide>${html}</swiper-slide>`).join("")}
            </swiper-container>
        </div>`
    }

    const child = section?.firstElementChild?.firstElementChild
    if (child) {
        initSwiperContainer(child as SwiperContainer, {
            modules: [Autoplay],
            injectStyles: [swiperCssAutoplay],
        })
    }
}

export async function fetchAdvertBanners() {
    return fetch(
        `/api/marketplace-banners?cardType=${getAdvertsCardType()}&location=${getLocation().slug}&isForNewsPage=true`,
    ).then((response) => response.json())
}

async function insertNewsPageMarketplaceBanners() {
    if (!bannersFromApi?.marketplaceBanners) {
        console.warn("No marketplace banners found!")
        return
    }

    for (const position of getNewsPageMarketplaceBannerPositionsMobile()) {
        if (marketplaceBannersInserted.includes(position)) {
            continue
        }

        if (insertAtPostion(position, bannersFromApi.marketplaceBanners[marketplaceBannerGetIndex])) {
            marketplaceBannersInserted.push(position)
        }

        // update get index
        marketplaceBannerGetIndex += 1
        if (marketplaceBannerGetIndex > bannersFromApi.marketplaceBanners.length) {
            marketplaceBannerGetIndex = 0
        }
    }
}

async function insertStaticBannersMobile() {
    for (const [bannerKey, banner] of Object.entries(staticBannersMobile)) {
        if (staticBannersInserted.includes(bannerKey)) {
            continue
        }

        if (banner.removableViaAdFree && userData.hasAdFree) {
            continue
        }

        if (insertAtPostion(banner.position, banner.html)) {
            staticBannersInserted.push(bannerKey)
        }
    }
}

function insertAtPostion(position: number, html: string) {
    const first4Cards = 4
    const announcementCardInsertIndex = position - first4Cards - 1
    const cardAfterInjectionAnnouncements = newsPageAnnouncementCards()[announcementCardInsertIndex]

    if (cardAfterInjectionAnnouncements && html) {
        cardAfterInjectionAnnouncements.insertAdjacentHTML("beforebegin", html)
        return true
    }

    return false
}

insertAllAdvertBanners()
window.addEventListener("news.view-type.change", (_) => {
    insertAllAdvertBanners()
})

window.addEventListener("news.pagination.change", (_) => {
    insertAllAdvertBanners()
})

window.addEventListener("news.next-distance.after-load", (_) => {
    insertAllAdvertBanners(true)
})
